<template>
  <div class="compliance-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Compliance Report</span>
      </div>

      <el-form :inline="true" :model="query" size="medium">
        <el-form-item label="Currency">
          <el-select v-loading="loadingCurrency" v-model="query.currency" placeholder="Currenct" style="width:100px">
            <el-option value="" label="All"></el-option>
            <el-option v-for="item in currencys" :key="item.uid" :value="item.currency" :label="item.currency.toUpperCase()"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="Transaction Date">
          <el-date-picker
            v-model="dateSearch"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="getComplianceData()">Query Export</el-button>
          <!-- <el-button type="success" icon="el-icon-download" @click="Report()">Export</el-button> -->
        </el-form-item>
      </el-form>

      <!-- <data-tables 
          v-loading="loading" 
          :data="tableData" 
          border 
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="created_date" label="Create Date" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="created_time" label="Time" header-align="center" align="center" width="80"> </el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="member_code" label="Member Code" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="bankholderID" label="BankholderID" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="project_name" label="Project Name" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="customer_name" label="Name" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="currency" label="Currency" header-align="center" align="center" width="80"> </el-table-column>
          <el-table-column prop="company_name" label="Agent Name" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="create_user" label="Authoirse Account" header-align="center" align="center" width="130"> </el-table-column>
          <el-table-column prop="region" label="Region" header-align="center" align="center" width="80"> </el-table-column>
          <el-table-column prop="total_transaction" label="Total Transaction" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="balance_start" label="Balance Start" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="impact_ledger" label="Impact Ledger" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="balance_end" label="Balance End" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="suspend" label="Suspend Number" header-align="center" align="center" width="130"> </el-table-column>
          <el-table-column prop="monthlycharge_suspend" label="Monthly Charge Suspend" header-align="center" align="center" width="180"> </el-table-column>
          <el-table-column prop="complianceORfraud_suspend" label="Compliance/Fraud Suspend" header-align="center" align="center" width="180"> </el-table-column>
        </data-tables> -->
        <ExportQueue ref="exportqueue"/>
    </el-card>
  </div>
</template>

<script>
import { getCurrencyList } from '@/api/currency'
import { getCompliance, getComplianceExcel } from '@/api/report'
import { currentDateTime, dateFormat } from '@/utils'
import ExportQueue from './export-queue.vue'
export default {  
  components:{
    ExportQueue
  },
  props:{
    project:String
  },
  watch: {
      project(val, old) {
        this.query.project_uid = val;
        this.getCurrencyList()
        //this.getComplianceData();
      }
  },
  data(){
    return{
      dateSearch: "",
      tableData: [],
      loading: false,
      loadingCurrency: false,
      currencys: [],
      query: {
        currency : "",
        project_uid: "",
        from : "",
        to: "",
      },
    }
  },
  methods:{
    getComplianceData(){
      this.SelectDate();
      if(!this.query.project_uid){
        this.$alert("Please select project", "Message");
        return false;
      }
      this.loading = true
      getCompliance(this.query).then(({result, message}) => {
        this.loading = false
        if(result){
          this.$notify({
            title: "Success",
            message: message,
            type: "success",
            duration: 2000
          });
          this.$refs.exportqueue.getQueueList();
        }else{
          this.$notify({
            title: "Error",
            message: message,
            type: "error",
            duration: 2000
          });
        }
      });
    },

    getCurrencyList(){
      if(!this.project) return;
      this.loadingCurrency = true;
      getCurrencyList(this.project).then(({result, data})=>{
        this.loadingCurrency = false
        if (result) {
          this.currencys = data;
          this.query.currency = ""
        }
      })
    },
    Report(){
      this.SelectDate();
      getComplianceExcel(this.query)
    },
    SelectDate(){
      this.query.project_uid = this.project || ""
      this.query.from = dateFormat(this.dateSearch[0], "YYYY-MM-DD") || currentDateTime("YYYY-MM-DD")
      this.query.to = dateFormat(this.dateSearch[1], "YYYY-MM-DD") || currentDateTime("YYYY-MM-DD")
    }
  },
  created(){
    this.getCurrencyList()
    // this.getComplianceData()
  }
};
</script>

<style>
</style>